import { connect } from "react-redux";
import { default as component } from "./CrowdContentOrdersCard.jsx";

// UI Selectors
import { getActiveModal } from "../../../common/UI/ActiveModal/duck/selectors";
// UI Actions
import { activateModal } from "../../../common/UI/ActiveModal/duck/actions";

// Local Selectors
import { getCrowdContentOrders } from "../../duck/selectors";

const mapStateToProps = (state) => {
  return {
    activeModal: getActiveModal(state),
    crowdContentOrders: getCrowdContentOrders(state),
  };
};

const mapDispatchToProps = {
  activateModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
